export default __webpack_public_path__ + "static/media/escoffier-heritage-badge.1b089fb1.svg";